/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { SpaceResource } from "@octopusdeploy/octopus-server-client";
import { projectsRoute } from "@octopusdeploy/portal-routes";
import * as React from "react";
import Task from "~/areas/tasks/components/Task/Task";
import { repository, session } from "~/clientInstance";
import ActionList from "~/components/ActionList";
import AreaTitle from "~/components/AreaTitle";
import { ContextualHelpLayout } from "~/components/ContextualHelpLayout/ContextualHelpLayout";
import DataBaseComponent from "~/components/DataBaseComponent";
import { PageHeaderPrimary } from "~/components/PageHeaderPrimary";
import { useIsPageHeaderVNextEnabled } from "~/components/RootRoutes/useIsPageHeaderVNextEnabled";
import Callout, { CalloutType } from "~/primitiveComponents/dataDisplay/Callout";
import ImportExportMenu, { importExportMenuItems } from "./ImportExportMenu";
import styles from "./style.module.less";
interface ImportTaskDetailsInternalProps extends ImportTaskDetailsProps {
    isPageHeaderVNextEnabled: boolean;
}
class ImportTaskDetailsInternal extends DataBaseComponent<ImportTaskDetailsInternalProps, {
    space?: SpaceResource;
}> {
    taskId: string;
    constructor(props: ImportTaskDetailsInternalProps) {
        super(props);
        this.taskId = this.props.taskId;
        this.state = {};
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const [space] = await Promise.all([repository.Spaces.get(repository.spaceId!)]);
            this.setState({
                space,
            });
        });
    }
    isSpaceManager(): boolean {
        return this.state.space !== undefined && session.currentPermissions!.isSpaceManager(this.state.space);
    }
    render() {
        return (<main>
                <ContextualHelpLayout>
                    {this.props.isPageHeaderVNextEnabled ? (<PageHeaderPrimary title="Import project" navUpLink={{ label: "Projects", linkHref: projectsRoute.generateUrl({ spaceId: this.props.spaceId }) }} overflowActions={importExportMenuItems}/>) : (<AreaTitle title="Projects" link={projectsRoute.generateUrl({ spaceId: this.props.spaceId })}>
                            <ActionList actions={[<ImportExportMenu />]}/>
                        </AreaTitle>)}
                    {this.state.space !== undefined && !this.isSpaceManager() && (<Callout title="Permissions" type={CalloutType.Danger}>
                            Only Space Managers can perform an export or import.
                        </Callout>)}
                    {this.state.space !== undefined && this.isSpaceManager() && (<div className={this.props.isPageHeaderVNextEnabled ? styles.containerVNext : styles.container}>
                            <Task taskId={this.taskId} delayRender={() => false}/>
                        </div>)}
                </ContextualHelpLayout>
            </main>);
    }
    static displayName = "ImportTaskDetailsInternal";
}
interface ImportTaskDetailsProps {
    spaceId: string;
    taskId: string;
}
export const ImportTaskDetails = (props: ImportTaskDetailsProps) => {
    const isPageHeaderVNextEnabled = useIsPageHeaderVNextEnabled();
    return <ImportTaskDetailsInternal {...props} isPageHeaderVNextEnabled={isPageHeaderVNextEnabled}/>;
};
